module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/operator@2x-2f4af9ac401a410ddce4a4e4ec4b229b.png";